module.exports = __webpack_public_path__ + "img/rise_winery.4f9c8b97.jpg";